import { SovosTypography } from "mosaic-react";

function Text({ title, isRequired }) {
  return (
    <SovosTypography variant="body2">
      {title} {isRequired && <span style={{ color: "red" }}>*</span>}
    </SovosTypography>
  );
}

export default Text;
